import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const CountryQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
  code: z.string().optional(),
});
export type CountryQueryDTO = z.infer<typeof CountryQuerySchema>;

export const CreateCountryRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  code: z.string().min(1, "El código es requerido"),
  flag: z.string().optional(),
});

export const UpdateCountryRequestSchema = CreateCountryRequestSchema.partial();

export type CreateCountryRequestDTO = z.infer<typeof CreateCountryRequestSchema>;
export type UpdateCountryRequestDTO = z.infer<typeof UpdateCountryRequestSchema>;

export const CountryResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  flag: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type CountryResponseDTO = z.infer<typeof CountryResponseSchema>;

export const CountriesPaginatedResponseSchema = PaginationResponseSchema(
  CountryResponseSchema
);
export type CountriesPaginatedResponseDTO = z.infer<
  typeof CountriesPaginatedResponseSchema
>;
